import React, { useState } from 'react';
import { LatLongIcon, MarkerIcon } from '@rsos/assets/icons';
import usePortalType from '@rsos/utils/usePortalType';
import HoveredButton from '../HoveredButton';
import { handleCopy } from './helpers/handleCopy';
import {
  CopyRowBox,
  LeftText,
  MiddleText,
  RowBox,
  IconWrapper,
} from './styles/common.styles';

const LatLong = ({
  longitude,
  latitude,
  isHoverable,
  irpVersion,
  w3w,
  payloadID,
  requestID,
}) => {
  const [isCopied, setIsCopied] = useState();
  const { portalType } = usePortalType();
  const onClick = () => {
    handleCopy({
      value: `${latitude}, ${longitude}`,
      name: 'Lat and Long',
      irpVersion,
      payloadID,
      requestID,
      onStart: () => {
        setIsCopied(true);
      },
      onEnd: () => {
        setIsCopied(false);
      },
      portalType,
    });
  };

  return (
    <RowBox isHoverable={isHoverable} px={2} copied={isCopied}>
      <RowBox pb={w3w && 3}>
        <RowBox px={2}>
          {w3w ? (
            <MarkerIcon width={16} height={15} color="#FF6969" />
          ) : (
            <IconWrapper>
              <LatLongIcon />
            </IconWrapper>
          )}
        </RowBox>
        <CopyRowBox data-name="location-lat-long">
          <LeftText>Lat/Long:&nbsp;</LeftText>
          <MiddleText data-name="location-lat-long-text">
            {parseFloat(latitude).toFixed(5)},&nbsp;
            {parseFloat(longitude).toFixed(5)}
          </MiddleText>
        </CopyRowBox>
      </RowBox>
      {isHoverable && (
        <HoveredButton onClick={onClick} withIcon isCopied={isCopied} />
      )}
    </RowBox>
  );
};

export default LatLong;
